import {isSameDay} from 'date-fns';

import {parseDate} from 'shared/web';

/**
 * Checks if an event spans multiple days
 * @param eventStart - The start date of the event
 * @param eventEnd - The end date of the event
 * @returns True if the event spans multiple days, false otherwise
 */
export function isMultiDayEvent(eventStart: string | Date, eventEnd: string | Date): boolean {
  const parsedEventStart = typeof eventStart === 'string' ? parseDate(eventStart) : eventStart;
  const parsedEventEnd = typeof eventEnd === 'string' ? parseDate(eventEnd) : eventEnd;

  return !isSameDay(parsedEventStart, parsedEventEnd);
}
